import { IS_BILLING_AVAILABLE } from '@libs/utils/environments'

import { HttpDirectBilling } from './HttpDirectBilling.class'
import { HttpDirectBillingFallback } from './HttpDirectBillingFallback'
import type { ExternalServicesType } from './HttpExternalServices'
import { httpExternalServices } from './HttpExternalServices'
import { HttpSnapApp } from './HttpSnapApp.class'
import type { HttpClientAuthState } from './interfaces/HttpClient.interface'

export class HttpServices {
  private httpSnapApp: HttpSnapApp

  private httpBilling: HttpDirectBilling | HttpDirectBillingFallback

  public httpExternal: ExternalServicesType

  constructor() {
    if (!IS_BILLING_AVAILABLE) {
      console.warn(
        '⚠️💸 Billing API is not available. BILLING_API_BASE_URL is not set.'
      )
    }

    this.httpSnapApp = new HttpSnapApp()
    this.httpBilling = IS_BILLING_AVAILABLE
      ? new HttpDirectBilling(this.httpSnapApp.core)
      : new HttpDirectBillingFallback()
    this.httpExternal = httpExternalServices.services
  }

  get core() {
    return this.httpSnapApp.core
  }

  get onboarding() {
    return this.httpSnapApp.onboarding
  }

  get billing() {
    return this.httpBilling.base
  }

  get external() {
    return this.httpExternal
  }

  public syncAuthState = (authState: Partial<HttpClientAuthState>) => {
    this.httpSnapApp.syncAuthState(authState)
  }

  get authInfo() {
    return this.httpSnapApp.authInfo
  }

  public setBillingJwt = (token: string) => {
    this.httpBilling.setBillingJwt(token)
  }

  public static contentTypes = {
    multipartFormData: { 'Content-Type': 'multipart/form-data' },
    applicationJson: { 'Content-Type': 'application/json' }
  }
}

export const httpServices = new HttpServices()
